import React from 'react';
import { arrayOf, bool, func, shape, string } from 'prop-types';
import { compose } from 'redux';
import { Form as FinalForm } from 'react-final-form';
import { intlShape, injectIntl, FormattedMessage } from '../../util/reactIntl';
import classNames from 'classnames';
import { propTypes } from '../../util/types';
import { maxLength, required, composeValidators } from '../../util/validators';
import {
  Form,
  Button,
  FieldTextInput,
  FieldCustomSelect,
  FieldWorkerJobCategory,
  InlineTextButton,
  FieldNumberInput,
} from '../../components';
import CustomCertificateSelectFieldMaybe from './CustomCertificateSelectFieldMaybe';
import arrayMutators from 'final-form-arrays';
// import css from './EditListingDescriptionForm.module.css';
import { listingTypes } from '../../marketplace-custom-config';
import { findOptionsByFilterLabel, findOptionsForSelectFilter } from '../../util/search';
import { category } from '../../marketplace-custom-config';
import config from '../../config';
import { FieldArray } from 'react-final-form-arrays';
import css from '../EditListingPricingForm/EditListingPricingForm.module.css';
import { createResourceLocatorString } from '../../util/routes';
import routeConfiguration from '../../routeConfiguration';
import { withRouter } from 'react-router-dom';

const TITLE_MAX_LENGTH = 60;

const textfield = 'textfield';
const errorTextField = 'errorTextField';

const EditListingDescriptionFormComponent = props => (
  <FinalForm
    {...props}
    mutators={{ ...arrayMutators }}
    render={formRenderProps => {
      // console.log(31, props);
      const {
        values,
        certificateOptions,
        className,
        disabled,
        ready,
        handleSubmit,
        intl,
        invalid,
        pristine,
        saveActionMsg,
        updated,
        filterConfig,
        updateInProgress,
        fetchErrors,
        formApi,
        formId,
        isRequired,
        name,
        form,
        history,
        jobCategories,
        userNativeLang,
      } = formRenderProps;

      // console.log(55, userNativeLang);
      const jobCategoryId = formId ? `${formId}.jobCategories` : 'jobCategories';

      // const {
      //   jobCategories = [],
      // } = values;

      // const titleMessage = intl.formatMessage({ id: 'EditListingDescriptionForm.title' });
      // const titlePlaceholderMessage = intl.formatMessage({
      //   id: 'EditListingDescriptionForm.titlePlaceholder',
      // });
      // const titleRequiredMessage = intl.formatMessage({
      //   id: 'EditListingDescriptionForm.titleRequired',
      // });
      // const maxLengthMessage = intl.formatMessage(
      //   { id: 'EditListingDescriptionForm.maxLength' },
      //   {
      //     maxLength: TITLE_MAX_LENGTH,
      //   }
      // );

      //your name

      const titleMessage = intl.formatMessage({ id: 'EditListingDescriptionForm.titleName' });
      const titlePlaceholderMessage = intl.formatMessage({
        id: 'EditListingDescriptionForm.titleNamePlaceholder',
      });
      const titleRequiredMessage = intl.formatMessage({
        id: 'EditListingDescriptionForm.titleNameRequired',
      });
      const maxLengthMessage = intl.formatMessage(
        { id: 'EditListingDescriptionForm.maxLength' },
        {
          maxLength: TITLE_MAX_LENGTH,
        }
      );
      //category

      const CategoryTitle = intl.formatMessage({
        id: 'EditListingDescriptionForm.CategoryTitle',
      });
      const CategoryPlaceholder = intl.formatMessage({
        id: 'EditListingDescriptionForm.CategoryPlaceholder',
      });

      const jobCategoryRequiredMessage = intl.formatMessage({
        id: 'FieldWorkerJobCateogry.jobCategoryRequired',
      });

      const jobCategoryValidator = isRequired
        ? validators.required(jobCategoryRequiredMessage)
        : null;
      //Sub- category

      const SubCategoryTitle = intl.formatMessage({
        id: 'EditListingDescriptionForm.SubCategoryTitle',
      });
      const SubCategoryPlaceholder = intl.formatMessage({
        id: 'EditListingDescriptionForm.SubCategoryPlaceholder',
      });

      const jobSubcategoryRequiredMessage = intl.formatMessage({
        id: 'FieldWorkerJobCateogry.jobSubcategoryRequired',
      });

      const jobSubcategoryValidator = isRequired
        ? validators.required(jobSubcategoryRequiredMessage)
        : null;
      //Worker you need

      const handleChange = e => {
        //  console.log(55, e);
        if (isNaN(e.workerYouNeed)) {
        } else {
          return null;
        }
      };

      const WorkerYouNeedTitle = intl.formatMessage({
        id: 'EditListingDescriptionForm.WorkerYouNeedTitle',
      });
      const WorkerYouNeedPlaceholder = intl.formatMessage({
        id: 'EditListingDescriptionForm.WorkerYouNeedPlaceholder',
      });

      const WorkerYouNeedRequiredMessage = intl.formatMessage({
        id: 'EditListingDescriptionForm.workerCountRequired',
      });

      const WorkerYouNeedValidator = isRequired
        ? validators.required(WorkerYouNeedRequiredMessage)
        : null;

      //Description
      const descriptionMessage = intl.formatMessage({
        id: 'EditListingDescriptionForm.JobDescription',
      });
      const descriptionPlaceholderMessage = intl.formatMessage({
        id: 'EditListingDescriptionForm.JobDescriptionPlaceholder',
      });
      const maxLength60Message = maxLength(maxLengthMessage, TITLE_MAX_LENGTH);
      const descriptionRequiredMessage = intl.formatMessage({
        id: 'EditListingDescriptionForm.descriptionRequired',
      });

      const { updateListingError, createListingDraftError, showListingsError } = fetchErrors || {};
      const errorMessageUpdateListing = updateListingError ? (
        <p className={css.error}>
          <FormattedMessage id="EditListingDescriptionForm.updateFailed" />
        </p>
      ) : null;

      // This error happens only on first tab (of EditListingWizard)
      const errorMessageCreateListingDraft = createListingDraftError ? (
        <p className={css.error}>
          <FormattedMessage id="EditListingDescriptionForm.createListingDraftError" />
        </p>
      ) : null;

      const errorMessageShowListing = showListingsError ? (
        <p className={css.error}>
          <FormattedMessage id="EditListingDescriptionForm.showListingFailed" />
        </p>
      ) : null;

      const classes = classNames(css.root, className);
      const submitReady = (updated && pristine) || ready;
      const submitInProgress = updateInProgress;
      const submitDisabled = invalid || disabled || submitInProgress || pristine;
      //  const categoryOptions = findOptionsForSelectFilter('category', filterConfig);
      const categoryOptions = findOptionsForSelectFilter('category', config.custom.filters);
      const subcategoryOptions = findOptionsForSelectFilter(
        'adminSubcategory',
        config.custom.filters
      );
      // const subcategoryOptions = findOptionsByFilterLabel('Subcategory', config.custom.filters);

      return (
        <Form className={classes} onSubmit={handleSubmit}>
          <div className={css.fieldDiv}>
            <FieldTextInput
              className={textfield}
              id="title"
              name="title"
              // className={css.title}
              type="text"
              label={titleMessage}
              placeholder={titlePlaceholderMessage}
              maxLength={TITLE_MAX_LENGTH}
              validate={composeValidators(required(titleRequiredMessage), maxLength60Message)}
              autoFocus
            />
          </div>

          <div className={css.jobCategoryDiv}>
            <FieldWorkerJobCategory
              formApi={form}
              id={jobCategoryId}
              name="jobCategories"
              userNativeLang={userNativeLang}
              titleClassName={css.workerJobCategoryTitle}
              values={jobCategories}
              isRequired={true}
              fromDescriptionForm={true}
            />
          </div>

          <div className={css.DescriptionfieldDiv}>
            <FieldTextInput
              className={textfield}
              id="description"
              name="description"
              // className={css.description}
              type="textarea"
              label={descriptionMessage}
              placeholder={descriptionPlaceholderMessage}
              validate={composeValidators(required(descriptionRequiredMessage))}
            />
          </div>
          <div className={css.WorkersfieldDiv}>
            <FieldNumberInput
              className={textfield}
              id="workerYouNeed"
              name="workerYouNeed"
              // className={css.title}
              type="text"
              label={WorkerYouNeedTitle}
              placeholder={WorkerYouNeedPlaceholder}
              validate={composeValidators(required(WorkerYouNeedRequiredMessage))}
            />
          </div>

          {/* <CustomCertificateSelectFieldMaybe
            id="certificate"
            name="certificate"
            certificateOptions={certificateOptions}
            intl={intl}
          />   */}
          {errorMessageCreateListingDraft}
          {errorMessageUpdateListing}
          {errorMessageShowListing}
          <div className={css.ButtonContainer}>
            <Button
              className={css.submitButton}
              type="submit"
              inProgress={submitInProgress}
              disabled={submitDisabled}
              ready={submitReady}
            >
              {saveActionMsg}
            </Button>
            <InlineTextButton
              type="button"
              className={css.cancelBtn}
              onClick={() => {
                // form.reset;
                history.replace(
                  createResourceLocatorString('ManageListingsPage', routeConfiguration())
                );
              }}
            >
              <FormattedMessage id="SignupForm.Cancel" />
            </InlineTextButton>
          </div>
        </Form>
      );
    }}
  />
);

EditListingDescriptionFormComponent.defaultProps = { className: null, fetchErrors: null };

EditListingDescriptionFormComponent.propTypes = {
  className: string,
  intl: intlShape.isRequired,
  onSubmit: func.isRequired,
  saveActionMsg: string.isRequired,
  disabled: bool.isRequired,
  ready: bool.isRequired,
  updated: bool.isRequired,
  updateInProgress: bool.isRequired,
  fetchErrors: shape({
    createListingDraftError: propTypes.error,
    showListingsError: propTypes.error,
    updateListingError: propTypes.error,
  }),
  certificateOptions: arrayOf(
    shape({
      key: string.isRequired,
      label: string.isRequired,
    })
  ),
};

export default compose(
  withRouter,
  injectIntl
)(EditListingDescriptionFormComponent);
